export default __webpack_public_path__ + "static/media/10.82936d27.jpeg";